import { render, staticRenderFns } from "./StyleColorControl.vue?vue&type=template&id=3ae81d8c&scoped=true&"
import script from "./StyleColorControl.vue?vue&type=script&lang=js&"
export * from "./StyleColorControl.vue?vue&type=script&lang=js&"
import style0 from "./StyleColorControl.vue?vue&type=style&index=0&id=3ae81d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae81d8c",
  null
  
)

export default component.exports